import { styled } from '@mui/material/styles';
import { defaultStyles, TooltipWithBounds } from '@visx/tooltip';
import React from 'react';

const maxWidth = 600;

const PREFIX = 'Tooltip';

const classes = {
  tooltip: `${PREFIX}-tooltip`,
  tooltipItem: `${PREFIX}-tooltipItem`
};

const StyledTooltipWithBounds = styled(TooltipWithBounds)(({ theme }) => ({
  [`& .${classes.tooltip}`]: {
    backgroundColor: theme.palette.info.light,
    color: theme.palette.info.contrastText,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    maxWidth
  },

  [`& .${classes.tooltipItem}`]: {
    paddingTop: theme.spacing(1),
    overflowWrap: 'break-word'
  }
}));

export type TooltipData = {
  name?: string;
  description?: string;
  attributes: { key: string; value?: string }[];
};
export interface TooltipProps {
  left: number;
  top: number;
  data?: TooltipData;
}

const tooltipStyles = {
  ...defaultStyles,
  backgroundColor: 'transparent',
  boxShadow: '0 0 0 0',
  padding: 0
};

export default ({ left, top, data }: TooltipProps) => {
  //  apply this if tool-tip will go to far behind the right border
  //  const tooltipLeft = left + maxWidth > windowWidth ? windowWidth - maxWidth - 30 : left;
  //  otherwise next seems to work well
  const tooltipLeft = left;

  return (
    <StyledTooltipWithBounds
      key={Math.random()} // needed for bounds to update correctly
      left={tooltipLeft}
      top={top}
      style={tooltipStyles}
    >
      <div className={classes.tooltip} id="tooltip-id">
        <div className={classes.tooltipItem} id="tooltip-name-id">
          <strong>{data?.name}</strong>
        </div>
        <div className={classes.tooltipItem} id="tooltip-description-id">
          <strong>{data?.description}</strong>
        </div>
        {data?.attributes.map(item => {
          return (
            item.value &&
            !['description', 'name'].includes(item.key.toLowerCase()) && (
              <div
                className={classes.tooltipItem}
                key={item.key}
                id={`tooltip-item-${item.key}-id`}
              >
                <strong>{item.key}:</strong> {item.value}
              </div>
            )
          );
        })}
      </div>
    </StyledTooltipWithBounds>
  );
};
